import { getAuth, signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from "@/firebase/init.js"

const signIn = async (email, password) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
    return true;  // Return true on successful sign-in
  } catch (error) {
    console.error('Error signing in:', error.code, error.message);
    // Return both error code and message for better handling
    return { code: error.code, message: error.message };
  }
}

export default signIn;
